import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "folder-open" }, [
      _createElementVNode("path", {
        id: "vector",
        d: "M4.5835 16.2503L6.66683 9.16699H17.0835M4.5835 16.2503H16.4585L18.5418 9.16699H17.0835M4.5835 16.2503H2.0835V2.91699H8.3335L10.0002 5.41699H17.0835V9.16699",
        stroke: "currentColor",
        "stroke-linecap": "round"
      })
    ], -1)
  ])))
}
export default { render: render }